import { render, staticRenderFns } from "./shippingConfig.vue?vue&type=template&id=30bf5474&scoped=true"
import script from "./shippingConfig.vue?vue&type=script&lang=js"
export * from "./shippingConfig.vue?vue&type=script&lang=js"
import style0 from "./shippingConfig.vue?vue&type=style&index=0&id=30bf5474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf5474",
  null
  
)

export default component.exports